import React, { useEffect, useState } from 'react'
import { DATE_DAILY, DATE_FILTER_TYPES, DATE_FORMAT_DISPLAY, DATE_FORMAT_SERVER, DATE_MONTHLY, DATE_WEEKLY, DATE_YEARLY } from '../../../../constants';
import { IoCalendarOutline } from "react-icons/io5"
import { Calendar } from 'react-date-range';
import { DateTime } from 'luxon';
import { useDetectClickOutside } from 'react-detect-click-outside';
import MonthlyCalendar from './MonthlyCalendar';
import YearCalendar from './YearCalendar';
import WeeklyCalendar from './WeeklyCalendar';

const DateFilterContainer = ({
  filter,
  setFilter,
  updateFilter,
}) => {
  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(0) //used to remove first sideeffect 

  const dateRanges = filter?.dateRanges || [];

  const setDateRanges = (newRanges) => {
    updateFilter("dateRanges", newRanges);
  };

  // Build display text from dateRanges
  const getDisplayValue = () => {
    if (!dateRanges.length) return "";

    if (dateRanges.length === 1) {
      const start = DateTime.fromISO(dateRanges[0].start).toFormat(DATE_FORMAT_DISPLAY);
      const end = DateTime.fromISO(dateRanges[0].end).toFormat(DATE_FORMAT_DISPLAY);
      return `${start} - ${end}`;
    }

    // Multiple ranges — show summary
    if (filter.dateType === DATE_MONTHLY.value) {
      return dateRanges.map(r => DateTime.fromISO(r.start).toFormat('MMM yyyy')).join(', ');
    }
    if (filter.dateType === DATE_YEARLY.value) {
      return dateRanges.map(r => DateTime.fromISO(r.start).toFormat('yyyy')).join(', ');
    }
    if (filter.dateType === DATE_WEEKLY.value) {
      return `${dateRanges.length} weeks selected`;
    }

    return `${dateRanges.length} ranges selected`;
  };

  useEffect(() => {
    if (count > 0) {
      setOpen(true);
    } else {
      setCount(1)
    }
  }, [filter.dateType])

  // close calender if clicked outside calender
  const ref = useDetectClickOutside({ onTriggered: () => setOpen(false) });

  return (
    <div ref={ref} className="relative mt-3 flex items-center">
      <IoCalendarOutline className="flex-shrink-0 text-2xl text-primary mr-2" />

      <div className="mr-2 inline-flex w-auto items-center justify-center p-1 bg-primary rounded-lg">
        {DATE_FILTER_TYPES.map((item, index) => (
          <button
            key={index}
            type="button"
            onClick={() => {
              let startDate;
              let endDate;

              if (item.value === DATE_DAILY.value) {
                startDate = DateTime.now().toFormat(DATE_FORMAT_SERVER);
                endDate = startDate;
              }

              if (item.value === DATE_WEEKLY.value) {
                startDate = DateTime.now().startOf("week").toFormat(DATE_FORMAT_SERVER);
                endDate = DateTime.now().endOf("week").toFormat(DATE_FORMAT_SERVER);
              }

              if (item.value === DATE_MONTHLY.value) {
                startDate = DateTime.now().startOf("month").toFormat(DATE_FORMAT_SERVER);
                endDate = DateTime.now().endOf("month").toFormat(DATE_FORMAT_SERVER);
              }

              if (item.value === DATE_YEARLY.value) {
                startDate = DateTime.now().startOf("year").toFormat(DATE_FORMAT_SERVER);
                endDate = DateTime.now().endOf("year").toFormat(DATE_FORMAT_SERVER);
              }

              // If same type clicked again, just open the modal without resetting
              if (filter.dateType === item.value) {
                setOpen(true);
                return;
              }

              updateFilter("dateType", item.value);
              // Reset to single default range when switching type
              updateFilter("dateRanges", [{ start: startDate, end: endDate }]);

              setOpen(true);
            }}
            className={`transition-all font-bold py-1 px-2 rounded-md text-xs ${filter.dateType === item.value
              ? "bg-white text-primary"
              : "text-white"
              }`}
          >
            {item.label}
          </button>
        ))}
      </div>

      {/* Display input */}
      <input
        onClick={() => setOpen(true)}
        readOnly
        value={getDisplayValue()}
        title={getDisplayValue()}
        className="!font-medium !text-xs input-text !w-[250px]"
      />

      {/* Calendars */}
      {filter.dateType === DATE_DAILY.value && open && (
        <Calendar
          color="#f8bd2c"
          className="absolute top-0 right-0 z-10 shadow-xl"
          onChange={(value) => {
            const date = DateTime.fromJSDate(value).toFormat(DATE_FORMAT_SERVER);

            setFilter(prev => ({
              ...prev,
              dateRanges: [{ start: date, end: date }],
            }));

            setOpen(false);
          }}
        />
      )}

      {filter.dateType === DATE_WEEKLY.value && open && (
        <WeeklyCalendar
          dateRanges={dateRanges}
          setDateRanges={setDateRanges}
        />
      )}

      {filter.dateType === DATE_MONTHLY.value && open && (
        <MonthlyCalendar
          dateRanges={dateRanges}
          setDateRanges={setDateRanges}
        />
      )}

      {filter.dateType === DATE_YEARLY.value && open && (
        <YearCalendar
          dateRanges={dateRanges}
          setDateRanges={setDateRanges}
        />
      )}
    </div>
  )
}

export default DateFilterContainer